import { render, staticRenderFns } from "./ActionOCSAddressCheck.vue?vue&type=template&id=95957e5a&scoped=true&"
import script from "./ActionOCSAddressCheck.vue?vue&type=script&lang=js&"
export * from "./ActionOCSAddressCheck.vue?vue&type=script&lang=js&"
import style0 from "./ActionOCSAddressCheck.vue?vue&type=style&index=0&id=95957e5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95957e5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VTextarea})
